const DAY_MAP = {
  Monday: 0,
  Tuesday: 1,
  Wednesday: 2,
  Thursday: 3,
  Friday: 4,
  Saturday: 5,
  Sunday: 6,
};

/**
 * @param {string} hoursOfOperation 
 * @returns {{start: string, end: string, hours: string}[]}
 */
export default function createHoursOfOperationMap(hoursOfOperation) {
  if (!hoursOfOperation) return [];

  const schedule = [];
  const shiftToIndex = {};
  const dayIndicesSeen = new Array(Object.keys(DAY_MAP).length).fill(false);
  const hoursOfOperationShifts = buildHoursOfOperationShifts(hoursOfOperation);
  if (!hoursOfOperationShifts) return [{ hours: hoursOfOperation }];

  for (const [day, hours] of hoursOfOperationShifts) {
    const dayIndex = DAY_MAP[day];
    if (hours in shiftToIndex && dayIndicesSeen[dayIndex - 1]) {
      const scheduleIndex = shiftToIndex[hours];
      if (dayIndex < DAY_MAP[schedule[scheduleIndex].start]) {
        schedule[scheduleIndex].start = day;
      } else {
        schedule[scheduleIndex].end = day;
      }
    } else {
      schedule.push({ start: day, end: day, hours });
      shiftToIndex[hours] = schedule.length - 1;
    }

    dayIndicesSeen[dayIndex] = true;
  }

  return schedule;
}

/**
 * @param {string} hoursOfOperation 
 * @returns {string[][] | null}
 */
function buildHoursOfOperationShifts(hoursOfOperation) {
  const shifts = [];
  const hoursOfOperationShifts = hoursOfOperation.trim().split(';');
  for (const shift of hoursOfOperationShifts) {
    const day = shift.match(/\w{6,9}/g)?.[0];
    if (!day) {
      continue;
    }

    const [, hours] = shift.split(day);
    shifts.push([day, hours]);
  }

  if (shifts.length === 0) return null;

  shifts.sort((a, b) => DAY_MAP[a[0]] - DAY_MAP[b[0]]);
  return shifts;
}
